import { CATEGORY_IDS } from '@/utilities/consts';

export const showTemplateDifficultyLevelFilter = categoryId => {
  return [CATEGORY_IDS.AFTER_EFFECTS_TEMPLATES_ID, CATEGORY_IDS.PREMIERE_PRO_TEMPLATES_ID].includes(
    categoryId,
  );
};
